import React from 'react';
import { Routes, Route } from "react-router-dom";

const SetStatus = ({statusCode, children}) => {
    return (
        <Routes>
            <Route
                path="*"
                element={children}
                render={({staticContext}) => {
                    if (staticContext) staticContext.statusCode = statusCode;
                    return children;
                }}
            />
        </Routes>
    );
};

export default SetStatus;